export default __webpack_public_path__ + "static/media/ISFP.165f709f.svg";